<template>
  <div class="quizz-container" v-if="!isFinish">
    <div v-for="(randomQuestion, key) in randomQuestions" :key="key">
      <question
        :plant="randomQuestion"
        v-if="key === currentQuestion"
        @submitQuestion="changeCurrentQuestion"
      />
    </div>
  </div>
  <!-- Perdu -->
  <div
    class="quizz-container"
    v-if="
      (isFinish && life === 0) ||
      (isFinish && score === 0) ||
      (life === 0 && score === 0)
    "
  >
    <div>
      <h3>Perdu</h3>
      <p>Vous avez perdu.</p>
      <p>score: {{ score }}/{{ result.responses.length }}</p>
      <button @click="replay">rejouer</button>
    </div>
  </div>
  <!-- Terminé -->
  <div
    class="quizz-container"
    v-if="
      isFinish && life > 0 && score > 0 && score < result.responses.length / 2
    "
  >
    <div>
      <h3>Terminé</h3>
      <p>Vous avez terminé.</p>
      <p>score: {{ score }}/{{ result.responses.length }}</p>
      <button @click="replay">rejouer</button>
    </div>
  </div>
  <!-- Gagné -->
  <div
    class="quizz-container"
    v-if="isFinish && score >= result.responses.length / 2"
  >
    <div>
      <h3>Gagné</h3>
      <p>Vous avez gagné.</p>
      <p>score: {{ score }}/{{ result.responses.length }}</p>
      <button @click="replay">rejouer</button>
    </div>
  </div>
  <correction v-if="isFinish" :result="result" />
</template>

<script>
import { mapGetters } from "vuex";
import correction from "./correction";
import question from "./question";
export default {
  name: "questions",
  components: {
    // gère les réponses possibles
    question,
    correction,
  },

  data() {
    return {
      randomQuestions: [],
      result: {
        responses: [],
      },
      currentQuestion: 0,
      isFinish: null,
    };
  },
  computed: {
    ...mapGetters({
      plants: "plants",
      life: "life",
      activePage: "activePage",
      difficulty: "difficulty",
      family: "family",
      game: "game",
      score: "score",
    }),
  },

  mounted() {
    setTimeout(() => {
      if (this.family === 51) {
        this.createRandomQuestions();
      } else {
        this.createRandomQuestionsWherefamily();
      }
    }, 50);
  },
  methods: {
    //Génère une liste mélangée de la famille selectionnée
    createRandomQuestionsWherefamily() {
      let questionfilter = this.plants.filter((question) => {
        return question.famille == this.family;
      });
      this.randomQuestions = questionfilter.sort(() => Math.random() - 0.5);
    },

    //Génère une liste mélangée de toutes les familles
    createRandomQuestions() {
      let randomArray = [];
      for (let i = 0; i < 20; i++) {
        const random = Math.floor(Math.random() * this.plants.length);

        if (!randomArray.includes(this.plants[random])) {
          randomArray.push(this.plants[random]);
        } else {
          i--;
        }
      }

      this.randomQuestions = randomArray;
    },

    //Renvoi un nombre aléatoire selon le max donné
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    changeCurrentQuestion(response) {
      const { id, toxic } = this.randomQuestions[this.currentQuestion];

      this.result.responses.push({
        goodResponse: this.randomQuestions[this.currentQuestion],
        response: response,
      });

      if (id !== response.plant.id && toxic !== response.toxicity) {
        this.$store.commit("losingLife");
        this.$store.commit("losingLife");
      } else if (id !== response.plant.id || toxic !== response.toxicity) {
        this.$store.commit("losingLife");
      } else {
        this.$store.commit("changeScore");
      }
      if (this.life === 0) {
        return (this.isFinish = true);
      }
      if (this.randomQuestions.length - 1 > this.currentQuestion) {
        this.currentQuestion++;
      } else {
        this.isFinish = true;
      }
    },
    replay() {
      this.randomQuestions = [];
      this.result = {
        responses: [],
      };
      this.currentQuestion = 0;
      this.isFinish = null;
      this.$store.commit("resetScore");
      this.$store.commit("resetLife");
      this.$store.commit("activePage", "level");
    },
  },
};
</script>

<style></style>
